'use client'

import { Download, FileText, Loader } from 'react-feather'
import { useTranslations } from '@/lib/next-shim'
import { Button } from '@/components/ui/button'
import { ExpertiseFile } from '../lib/expertise-detail.types'

type FileItemProps = {
  file: ExpertiseFile
  isDownloading: boolean
  onDownload: (file: ExpertiseFile) => void
}

export function FileItem({ file, isDownloading, onDownload }: FileItemProps) {
  const t = useTranslations()

  return (
    <li className="flex items-center justify-between gap-2 rounded-lg px-2 py-1.5 hover:bg-gray-50">
      <span className="flex min-w-0 flex-1 items-center gap-2">
        <FileText size={16} className="shrink-0 text-primary" aria-hidden="true" />
        <span className="min-w-0 truncate text-sm" title={file.filename}>
          {file.filename}
        </span>
      </span>
      <Button
        variant="ghost"
        size="icon"
        className="shrink-0 text-gray-600"
        aria-label={t('account.expertises.download')}
        onClick={() => onDownload(file)}
        disabled={!file.url || isDownloading}
      >
        {isDownloading ? <Loader size={16} className="animate-spin" aria-hidden="true" /> : <Download size={16} aria-hidden="true" />}
      </Button>
    </li>
  )
}
